import React from 'react';
import Slider from 'react-slick';
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Card, CardContent } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';

const slides = [
	{
		slideTitle: 'SSIS Social Skills Screening',
		subTitles: [
			'SSIS is a well-know indirect functional assessment method.',
			'It is comprised of a self-report checklist to identity retained behavior challenges. ',
			'The assessment is a short 16 item checklist of “yes,” “no,” or “not applicable.” responses'
		]
	},

	{
		slideTitle: 'ABLES Basic Language & Learning Screening',
		subTitles: [
			'ABLES is a popular assessment method practiced by experts worldwide.',
			'It is comprised of a self-report checklist to identity retained behavior challenges. ',
			'The assessment is a short 16 item checklist of “yes,” “no,” or “not applicable.” responses'
		]
	},

	{
		slideTitle: 'Verbal Behavior (v-MAP) Screening',
		subTitles: [
			'VMAP is a well-know indirect functional assessment method.',
			'It is comprised of a self-report checklist to identity retained behavior challenges. ',
			'The assessment is a short 16 item checklist of “yes,” “no,” or “not applicable.” responses'
		]
	},

	{
		slideTitle: 'PEAK Screening',
		subTitles: [
			'PEAK Screening is a well-know indirect functional assessment method.',
			'It is comprised of a self-report checklist to identity retained behavior challenges. '
		]
	}
];

const FSSDevSkillDeficiencyScreening = () => {
	const theme = useTheme();

	const sliderOpts = {
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 500
	};

	return (
		<Box
			sx={{
				position: 'relative',
				boxShadow: 0
			}}>
			<Box
				position={'relative'}
				zIndex={2}
				paddingX={2}
				paddingTop={{ xs: 0, sm: 0, md: 6, lg: 6 }} // needed to align slides to left-side content
				marginX={{ xs: 'auto', sm: 'auto', md: '0px' }}
				backgroundColor={'none'}
				borderRadius={3}>
				<Box
					maxWidth={{ xs: '75vw', sm: '85vw', md: '68vw', lg: '68vw' }}
					marginX={'auto'}
					paddingX={'auto'}
					marginY={0}
					paddingY={0}>
					<Box
						marginX={'auto'}
						paddingX={'auto'}
						marginBottom={{ sm: 8, md: 8, xs: 8 }}
						paddingY={0}
						sx={{
							height: { xs: 'auto', md: 1 },
							'& .slick-slide img': {
								objectFit: 'cover'
							},
							'& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div': {
								height: { xs: 'auto', md: 1 }
							},
							'& .slick-dots': {
								marginTop: { xs: 2, sm: 2, md: 2, lg: 2 },
								top: { xs: '84%', sm: '90%', md: '87%' },
								height: '25px'
							},
							'& .slick-prev': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '0%',
								marginLeft: 0,
								marginRight: '32px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							},
							'& .slick-next': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '100%',
								marginLeft: '62px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							}
						}}>
						<Slider {...sliderOpts}>
							{slides.map((item, i) => (
								<Box key={i}>
									<Card
										sx={{
											display: 'flex',
											flexDirection: {
												xs: 'column',
												md: (i + 1) % 2 === 0 ? 'row' : 'row-reverse'
											},
											boxShadow: 0,
											background: 'transparent'
										}}>
										<CardContent
											sx={{
												display: 'flex',
												alignItems: 'left',
												marginLeft: { sx: 0, md: 2 }
											}}>
											<Box>
												<Box marginBottom={2}>
													<SimTypography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
														{item.slideTitle}
													</SimTypography>

													{item.subTitles?.length && (
														<SimTypography color={theme.palette.text.secondary}>
															{item.subTitles.map(subTitle => (
																<Box key={subTitle}>{subTitle}</Box>
															))}
														</SimTypography>
													)}
												</Box>

												<Box
													display={'flex'}
													justifyContent={{ xs: 'center', md: 'flex-start' }}>
													<SimButton
														href={'/resources'}
														endIcon={
															<Box
																component={'svg'}
																xmlns='http://www.w3.org/2000/svg'
																fill='none'
																viewBox='0 0 24 24'
																stroke='currentColor'
																width={24}
																height={24}>
																<path
																	strokeLinecap='round'
																	strokeLinejoin='round'
																	strokeWidth={2}
																	d='M17 8l4 4m0 0l-4 4m4-4H3'
																/>
															</Box>
														}>
														Read More
													</SimButton>
												</Box>
											</Box>
										</CardContent>
									</Card>
								</Box>
							))}
						</Slider>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { FSSDevSkillDeficiencyScreening };
